<template>
  <div class="echarts" id="houseecharts"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,

  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import * as echarts from "echarts";
import { crouchChart } from "@/api/publicSecurityResearch/keyCarPerson.js";
import { formatDateHMS } from "@/utils/index.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsDay: {
        name: [],
        value: [],
      },
      echartsNight: {
        name: [],
        value: [],
      },
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const params = {
        endTime: formatDateHMS(new Date()),
        beginTime: formatDateHMS(new Date().getTime() - 24 * 3600 * 1000 * 7),
      };
      const res = await crouchChart(params);
      console.log(res);
      if (res.code == 0) {
        res.data.dayPoints.forEach((element) => {
          data.echartsDay.name.push(element.hour);
          data.echartsDay.value.push(element.count);
        });
        res.data.nightPoints.forEach((element) => {
          data.echartsNight.name.push(element.hour);
          data.echartsNight.value.push(element.count);
        });
      }
    };
    let myhouseecharts;
    const houseecharts = async () => {
      await numberall();
      myhouseecharts = echarts.init(document.getElementById("houseecharts"));
      const option = {
        grid: {
          top: 40,
          left: 50,
          right: 30,
          bottom: 50,
          // containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        xAxis: {
          data: data.echartsDay.name,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#08598f", // 横坐标线条颜色
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            // 网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed", // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, // 隐藏或显示
          },
        },
        series: [
          {
            data: data.echartsNight.value,
            type: "line",
            smooth: true,
            areaStyle: {
              // 折线图颜色半透明
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,198,0, 0.5)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(255,198,0, 0.1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            itemStyle: {
              normal: {
                color: "#6881cc", // 折点颜色
                lineStyle: {
                  color: "#6881cc", // 折线颜色
                },
              },
            },
          },
          {
            data: data.echartsNight.value,
            type: "line",
            smooth: true,
            areaStyle: {
              // 折线图颜色半透明
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(36,173,254, 0.5)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(52,112,252, 0.1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            itemStyle: {
              normal: {
                color: "#6881cc", // 折点颜色
                lineStyle: {
                  color: "#6881cc", // 折线颜色
                },
              },
            },
          },
        ],
      };
      //   option && data.myChart.setOption(option);
      //   data.myChart.on('click', function(params) {
      //     context.emit('dialogSate', true); ;
      //   });
      // };
      myhouseecharts.setOption(option);
    };
    onMounted(() => {
      houseecharts();
      window.addEventListener("resize", () => {
        myhouseecharts.resize();
      });
    });

    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
#houseecharts {
  width: 100%;
  height: 90%;
}
</style>
